import { render } from "./fuel.vue?vue&type=template&id=bb8d0288"
import script from "./fuel.vue?vue&type=script&lang=js"
export * from "./fuel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__